import downloadFile from '../../../../helpers/downloadFile';
import apiClient from '../../../../services/api';
import { getDownloadBookingConfirmationRoute } from '../../../../services/routes';
import { DownloadPdfParams } from './types';

const downloadBookingConfirmation = async (variables: DownloadPdfParams): Promise<unknown> => {
    const { unid, prettifiedUnid } = variables;

    const result = await apiClient
        .get(getDownloadBookingConfirmationRoute(unid), { responseType: 'blob' })
        .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));

            downloadFile(url, `GET-E Booking Confirmation ${prettifiedUnid}.pdf`);
        })
        .catch(error => {
            console.log(error);
        });

    return result;
};

export default downloadBookingConfirmation;
